import { AlertTriangle, Zap, CalendarClock } from "lucide-react";

export const URGENCY = {
  urgent: {
    key: "urgent",
    label: "Urgent (24h)",
    short: "URGENT",
    icon: AlertTriangle,
    badge: "bg-red-500/10 text-red-600 dark:text-red-400 border border-red-500/30",
    dot: "bg-red-500",
  },
  stock: {
    key: "stock",
    label: "En stock",
    short: "EN STOCK",
    icon: Zap,
    badge: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/30",
    dot: "bg-emerald-500",
  },
  delay: {
    key: "delay",
    label: "Délai (1 à 7 jours)",
    short: "DÉLAI",
    icon: CalendarClock,
    badge: "bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/30",
    dot: "bg-blue-500",
  },
};

export const STATUS = {
  pending: { label: "En attente", cls: "bg-amber-500/10 text-amber-600 border border-amber-500/30" },
  quoted: { label: "Devis reçu", cls: "bg-blue-500/10 text-blue-600 border border-blue-500/30" },
  validated: { label: "Validé", cls: "bg-emerald-500/10 text-emerald-600 border border-emerald-500/30" },
  refused: { label: "Refusé", cls: "bg-red-500/10 text-red-600 border border-red-500/30" },
  processed: { label: "Traité", cls: "bg-slate-500/10 text-slate-600 border border-slate-500/30" },
};

export const PARTS_CATALOGUE = [
  { key: "freinage", label: "Freinage", items: ["Plaquettes de frein", "Disques de frein", "Étrier de frein", "Kit de frein", "Flexible de frein", "Maître-cylindre", "Capteur ABS"] },
  { key: "filtration", label: "Filtration", items: ["Filtre à huile", "Filtre à air", "Filtre habitacle", "Filtre à carburant", "Filtre à gasoil"] },
  { key: "distribution", label: "Distribution", items: ["Kit de distribution", "Courroie de distribution", "Galet tendeur", "Pompe à eau", "Courroie d'accessoire"] },
  { key: "embrayage", label: "Embrayage", items: ["Kit d'embrayage", "Volant moteur bi-masse", "Butée d'embrayage", "Émetteur d'embrayage", "Récepteur d'embrayage"] },
  { key: "suspension", label: "Suspension & Direction", items: ["Amortisseur", "Rotule de direction", "Biellette de barre stabilisatrice", "Triangle de suspension", "Roulement de roue", "Cardan de transmission"] },
  { key: "moteur", label: "Moteur", items: ["Injecteur", "Turbocompresseur", "Vanne EGR", "Bougie de préchauffage", "Débitmètre d'air", "Joint de culasse", "Support moteur"] },
  { key: "refroidissement", label: "Refroidissement", items: ["Radiateur", "Thermostat", "Durite de refroidissement", "Ventilateur moteur", "Vase d'expansion"] },
  { key: "echappement", label: "Échappement", items: ["Silencieux", "Catalyseur", "Sonde lambda", "FAP (filtre à particules)", "Ligne d'échappement"] },
  { key: "electrique", label: "Électrique & Allumage", items: ["Batterie", "Alternateur", "Démarreur", "Bobine d'allumage", "Bougie d'allumage", "Capteur PMH"] },
  { key: "eclairage", label: "Éclairage", items: ["Ampoule de phare", "Bloc optique avant", "Feu arrière", "Feu clignotant"] },
];
